<script>
import moment from 'moment';
export default {
  name: 'VideoSquareTile',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
    videoImageUrl: {
      type: String,
      required: true,
    },
    videoDuration: {
      type: String,
      required: true,
    },
    videoPublishedAt: {
      type: String,
      required: true,
    },
  },
  computed: {
    timeFromPublish() {
      moment.updateLocale('en', {
        relativeTime: {
          future: 'in %s',
          past: '%s ago',
          s: '1s',
          ss: '%ss',
          m: '1m',
          mm: '%dm',
          h: '1h',
          hh: '%dh',
          d: '1d',
          dd: '%dd',
          M: '1 month',
          MM: '%dM',
          y: '1 year',
          yy: '%dY',
        },
      });
      return moment
        .utc(this.videoPublishedAt)
        .local()
        .fromNow(true);
    },
  },
};
</script>

<template>
  <div class="video-square__container">
    <div class="video-square__wrapper">
      <!-- Video tile -->
      <div v-lazy:background-image="videoImageUrl" class="video-square__image">
        <h3 class="video-square__title">{{ videoTitle }}</h3>
        <div class="video-square__play-container">
          <div class="video-square__play-button"></div>
          <div class="video-square__duration">
            <p>{{ videoDuration }}</p>
          </div>
        </div>
        <h4 class="video-square__published">{{ timeFromPublish }}</h4>
      </div>
    </div>
  </div>
</template>
